import { toAlpha } from "./numberToAlphabetical";
import { toRoman } from "./numberToRoman";

export const processHtmlContent = (html) => {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;

  const checkboxes = Array.from(tempDiv.querySelectorAll('input[type="checkbox"]'));
  checkboxes.forEach((checkbox) => {
    checkbox.remove();
  });

  // indentations
  const wrapChildrenWithIndent = (el) => {
    const wrapper = document.createElement("div");
    wrapper.style.marginLeft = "-0.5em";
    while (el.firstChild) {
      wrapper.appendChild(el.firstChild);
    }
    el.parentNode.insertBefore(wrapper, el);
    el.parentNode.removeChild(el);
  };

  const removeAndIndentTags = (tag) => {
    const elements = Array.from(tempDiv.getElementsByTagName(tag));
    elements.forEach((el) => {
      wrapChildrenWithIndent(el);
    });
  };
  removeAndIndentTags("ul");

  // Spacings
  const allLiElements = Array.from(tempDiv.getElementsByTagName("li"));
  allLiElements.forEach((li) => {
    li.style.marginBottom = "1.5em";
    li.style.marginTop = "1.5em";
  });

  allLiElements.forEach((li) => {
    if (!li.parentElement || li.parentElement.tagName.toLowerCase() !== "ol") {
      const wrapper = document.createElement("div");
      wrapper.style.marginBottom = "1em";
      wrapper.style.marginTop = "1em";

      while (li.firstChild) {
        wrapper.appendChild(li.firstChild);
      }

      li.parentNode.insertBefore(wrapper, li);
      li.parentNode.removeChild(li);
    }
  });

  const allOlElements = Array.from(tempDiv.getElementsByTagName("ol"));
  allOlElements.forEach((ol) => {
    ol.style.listStyleType = "none"; // remove browser default numbering here

    // determine nesting level
    let level = 1;
    let parent = ol.parentElement;
    while (parent) {
      if (parent.tagName && parent.tagName.toLowerCase() === "li") {
        const parentOl = parent.parentElement;
        if (parentOl && parentOl.tagName && parentOl.tagName.toLowerCase() === "ol") {
          level += 1;
          parent = parentOl.parentElement;
        } else {
          break;
        }
      } else {
        break;
      }
    }

    const lis = Array.from(ol.children).filter((el) => el.tagName.toLowerCase() === "li");

    let idx = 0;
    while (idx < lis.length) {
      const li = lis[idx];
      let marker;

      // nesting levels - numbers/roman numerals/alphabetical
      if (level === 1) {
        marker = `${idx + 1}.`;
      } else if (level === 2) {
        marker = `${toRoman(idx + 1)}.`;
      } else {
        marker = `(${toAlpha(idx + 1)})`;
      }

      if (li.childNodes.length > 0 && li.childNodes[0].nodeType === Node.TEXT_NODE) {
        const cleanedText = li.childNodes[0].textContent
          .replace(/^\s*\d+(?:\.\d+)*\.?\s*/, "")
          .trim();
        li.childNodes[0].textContent = `${marker} ${cleanedText}`;
      } else {
        li.insertBefore(document.createTextNode(`${marker} `), li.firstChild);
      }

      idx += 1;
    }
  });

  // Table processing
  const allTables = Array.from(tempDiv.getElementsByTagName("table"));
  allTables.forEach((table) => {
    table.classList.add("legal-table");

    const allCells = Array.from(table.querySelectorAll("td, th"));
    allCells.forEach((cell) => {
      const paragraphs = Array.from(cell.querySelectorAll("p"));
      paragraphs.forEach((p) => {
        if (!p.textContent.trim()) {
          p.remove();
        }
      });

      const remainingParagraphs = Array.from(cell.querySelectorAll("p"));
      if (remainingParagraphs.length > 0) {
        remainingParagraphs.forEach((p, index) => {
          if (index > 0) {
            p.style.marginTop = "0.5em";
          }
        });
      }

      if (cell.textContent.trim() && !cell.querySelector("p")) {
        const textContent = cell.textContent.trim();
        const pElement = document.createElement("p");
        pElement.textContent = textContent;
        cell.innerHTML = "";
        cell.appendChild(pElement);
      }
    });

    const wrapper = document.createElement("div");
    wrapper.className = "table-responsive";
    wrapper.style.overflowX = "auto";
    wrapper.style.marginBottom = "1em";

    table.parentNode.insertBefore(wrapper, table);
    wrapper.appendChild(table);
  });

  const processed = tempDiv.innerHTML.replace(/•/g, "").replace(/^[ \t]*[\r\n]/gm, "");

  return processed;
};
